import { Instance } from 'mobx-state-tree';
import { SignatureDtoModelBase } from './SignatureDtoModel.base';

/* The TypeScript type of an instance of SignatureDtoModel */
export interface SignatureDtoModelType extends Instance<typeof SignatureDtoModel.Type> { }

/* A graphql query fragment builders for SignatureDtoModel */
export { selectFromSignatureDto, signatureDtoModelPrimitives, SignatureDtoModelSelector } from './SignatureDtoModel.base';

/**
 * SignatureDtoModel
 */
export const SignatureDtoModel = SignatureDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
